import React from 'react';
import './FilterSidebar.css';

const SIZES = ['XS', 'S', 'M', 'L', 'XL', 'XXL'];

export default function FilterSidebar({
  categories,
  sports,
  filters,
  onFilterChange,
  onClearFilters,
  isMobileOpen,
  onMobileClose,
  allowedSportIds, // when set, restricts visible sports to these IDs (used in Equipamentos)
}) {
  const hasActiveFilters = filters.categoryId || filters.sportId || filters.size;

  // When in Equipamentos, only show the athlete's sports in the Modalidade filter
  const visibleSports = allowedSportIds
    ? sports.filter(s => allowedSportIds.includes(s.id))
    : sports;

  return (
    <>
      {/* Mobile backdrop */}
      {isMobileOpen && (
        <div className="filter-mobile-backdrop" onClick={onMobileClose} aria-hidden="true" />
      )}

      <aside className={`filter-sidebar ${isMobileOpen ? 'mobile-open' : ''}`} aria-label="Filtros de produto">
        <div className="filter-sidebar-header">
          <h3 className="filter-sidebar-title">
            <i className="fas fa-sliders-h" /> Filtrar
          </h3>
          {hasActiveFilters && (
            <button className="filter-clear-btn" onClick={onClearFilters}>
              Limpar tudo
            </button>
          )}
          <button className="filter-mobile-close" onClick={onMobileClose} aria-label="Fechar filtros">
            <i className="fas fa-times" />
          </button>
        </div>

        {/* Categories */}
        <FilterGroup title="Categoria">
          <ul className="filter-options">
            <li>
              <button
                className={`filter-option ${!filters.categoryId ? 'active' : ''}`}
                onClick={() => onFilterChange('categoria', null)}
              >
                Todos
              </button>
            </li>
            {categories.map(cat => (
              <li key={cat.id}>
                <button
                  className={`filter-option ${filters.categoryId === cat.id ? 'active' : ''}`}
                  onClick={() => onFilterChange('categoria', filters.categoryId === cat.id ? null : cat.id)}
                >
                  {cat.name}
                </button>
              </li>
            ))}
          </ul>
        </FilterGroup>

        {/* Modalidade */}
        <FilterGroup title="Modalidade">
          <ul className="filter-options">
            <li>
              <button
                className={`filter-option ${!filters.sportId ? 'active' : ''}`}
                onClick={() => onFilterChange('modalidade', null)}
              >
                Todas
              </button>
            </li>
            {visibleSports.map(sport => (
              <li key={sport.id}>
                <button
                  className={`filter-option ${filters.sportId === sport.id ? 'active' : ''}`}
                  onClick={() => onFilterChange('modalidade', filters.sportId === sport.id ? null : sport.id)}
                >
                  {sport.name}
                </button>
              </li>
            ))}
          </ul>
        </FilterGroup>
      </aside>
    </>
  );
}

function FilterGroup({ title, children }) {
  const [open, setOpen] = React.useState(false);
  return (
    <div className="filter-group">
      <button
        className="filter-group-header"
        onClick={() => setOpen(o => !o)}
        aria-expanded={open}
      >
        <span>{title}</span>
        <i className={`fas fa-chevron-${open ? 'up' : 'down'}`} />
      </button>
      <div className={`filter-group-body ${open ? 'open' : ''}`}>
        {children}
      </div>
    </div>
  );
}
